<template>
    <iframe :src="iframeSrc" seamless="seamless"  style="width: 100%;height: 100%"></iframe>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, onUnmounted} from "vue";

    const props = defineProps(["id", "tag"])
    const emits = defineEmits(['save-success'])

    let { proxy } = getCurrentInstance();

    const iframeSrc = ref(null)

    function generateIframeSrc(){
        if (null == props.id){
            iframeSrc.value = null
            return
        }

        if (props.tag === "saveCard"){
            iframeSrc.value = `${proxy.$ShopopeeUrl}memberwork_editor?id=${props.id}&iframetag=saveTemplate`
        }
    }

    function listenIframeEvent(e) {
        if (e.data.type == 'templateSave'){
            emits("save-success")
        }
    }

    onMounted(() => {
        window.addEventListener("message", listenIframeEvent)
        generateIframeSrc()
    })

    onUnmounted(() => {
        window.removeEventListener("message", listenIframeEvent)
    })
</script>

<style scoped>

</style>